export const TagVisibility = {
    ALL: 'all',
    PRODUCT_PAGE_ONLY: 'product_page_only',
    PRODUCT_LIST_ONLY: 'product_list_only'
}

export const TagVisibilityTranslationKey = {
    'all': 'tagVisibility.all',
    'product_page_only': 'tagVisibility.product_page_only',
    'product_list_only': 'tagVisibility.product_list_only'
}